// @ts-check
// FIXME:
// 目前先安裝 1.2.48 版本，待官方有解決後，再升級到 2 以上版本
// Module not found: Can't resolve 'ably' after upgrading to 2.0.3 #1751
// https://github.com/ably/ably-js/issues/1751
import * as Ably from 'ably';
import { isNil } from 'lodash-es';

import { useNonComponentHook } from '@/composables/useHookPair';
import { tre } from '@/plugins/bugsnag';

export const useAbly = (key: string, userId: string) => {
  const ably = new Ably.Realtime({
    key,
    clientId: userId,
    restHost: import.meta.env.VITE_APP_ABLY_REST_HOST,
  });

  const getUUID = () => {
    if (isNil(ably)) {
      const error = new Error('ably cannot be null');
      tre(error);
      throw error;
    }

    return ably.auth.clientId;
  };

  // #region post channels
  const [triggerMessageEvent, onMessageEvent] = useNonComponentHook();

  const subscribePostChannels = (channels: string[]) => {
    if (isNil(ably)) {
      const error = new Error('ably cannot be null');
      tre(error);
      throw error;
    }

    channels.forEach((channel: string) => {
      const ablyChannel = ably.channels.get(channel);
      ablyChannel.subscribe((message: Ably.Types.Message) => {
        triggerMessageEvent({
          channel,
          message: message.data,
          timetoken: message.timestamp,
        });
      });
    });
  };
  // #endregion post channels

  const destroy = () => {
    if (isNil(ably)) {
      tre(new Error('ably already destroy'));
      return;
    }

    ably.close();
  };

  return {
    type: 'ably',
    getUUID,
    subscribePostChannels,
    onMessageEvent,
    destroy,
  };
};
